<template id="flow-template">
  <div class="flextop">
     <div class="flexout"><span class="text">24小时地质监测</span></div> 
     <!-- 曲线图 -->
     <div class="zhe_box">
      <div class="trend_box" v-for="(item,index) in arr" :key="index">
        <p class="title">{{item.name}}</p>
        <p class="title" v-if="item.type=='x'">平均{{realtimeData.xveg}} 最高{{realtimeData.xmax}} 最低{{realtimeData.xmin }}</p>
        <p class="title" v-if="item.type=='y'">平均{{realtimeData.yveg}} 最高{{realtimeData.ymax }} 最低{{realtimeData.ymin}}</p>
        <p class="title" v-if="item.type=='z'">平均{{realtimeData.zveg}} 最高{{realtimeData.zmax }} 最低{{realtimeData.zmin }}</p>

        <p class="title" v-if="item.type=='h'">平均{{realtimeData.horveg}} 最高{{realtimeData.hormax}} 最低{{realtimeData.hormin }}</p>
        <p class="title" v-if="item.type=='v'">平均{{realtimeData.verveg}} 最高{{realtimeData.vermax}} 最低{{realtimeData.vermin }}</p>
        <div class="trend-chart">
          <div class="echartGeology" :id="item.type"></div>
        </div>
      </div>
     </div>
    
  </div>
</template>

<script>
import MyApis from "../../../apis";
 import {placeChart} from '../../../../../../request/api';
export default {
  name: "HomeViewFlow",
  componentName: "HomeViewFlow",
  data() {
    return {
      arr:[
        {
          name:"X位移",
          type:"x"
        },
        {
          name:"Y位移",
          type:"y"
        },
        {
          name:"Z位移",
          type:"z"
        },
        {
          name:"水平位移",
          type:"h"
        },
        {
          name:"垂直位移",
          type:"v"
        }
      ],
      realtimeData:"",
      time: [],
      trendyDataZ:[],
      trendyDataX:[],
      trendyDataY:[],
      trendyDataH:[],
      trendyDataV:[]
    };
  },
  created() {
     this.getPlace();
  },
  mounted() {
   
  },
  methods: {
    getPlace(){
      let _this=this;
      let params={}
        //  params = JSON.stringify(params);
      placeChart(params).then(res=>{   
          console.log("地质折线====")
          console.log(res) 
          let data = res.data;
           _this.trendyDataX = data.XList;
           _this.trendyDataY = data.yList;
           _this.trendyDataZ = data.zList;
           _this.trendyDataH = data.horizontalList;
           _this.trendyDataV = data.verticalList;
           _this.realtimeData = data;
           _this.time = data.date;
          _this.drawZhe(data.XList,"x")
          _this.drawZhe(data.yList,"y")
          _this.drawZhe(data.zList,"z")
          _this.drawZhe(data.horizontalList,"h")
          _this.drawZhe(data.verticalList,"v")
        })
    },
    drawZhe(dataY,id){
      let _this=this;
      var myChart=echarts.init(document.getElementById(id));
        //指定图表的配置项和数据
      var option={
        tooltip: {
          trigger: 'axis'
        },
        grid: {
            left: '5%',
            right: '5%',
            top: '20%',
            bottom: '10%',
            containLabel: true
        },
        calculable: true,
        xAxis: [
            {
                type: 'category',
                name: '',
                nameTextStyle: {
                    color: '#9ab9ca',
                    //fontSize: 12
                },
                boundaryGap: false,
                axisLine: {
                    lineStyle: {
                        color: '#18396E'
                    }
                },
                axisLabel: {
                    textStyle: {
                        //fontSize: 12,
                        color: '#9ab9ca'
                    }
                },
                data: _this.time 
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '',
                nameTextStyle: {
                    color: '#9ab9ca',
                    //fontSize: 12,
                    //align: "left",
                    padding: 0
                },
                axisLine: {
                    lineStyle: {
                        color: '#18396E'
                    }
                },
                axisLabel: {
                    textStyle: {
                        //fontSize: 12,
                        color: '#9ab9ca'
                    }
                },
                splitLine: {
                    show: false
                }
            }
        ],
        series: [
            {
                name: "",
                type: 'line',
                smooth: true,
                symbol: 'none',
                interval: true,
                itemStyle: {
                    normal: {
                        areaStyle: {
                            opacity: 0.2,
                            color: '#2CC8FF'
                        }
                    }
                },
                markPoint: {
                    symbol: 'circle',
                    symbolSize:5,
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                fontSize: 1,
                                color: '#2CC8FF'
                            }
                        }
                    },
                    data: [{
                        type: 'max',
                        name: '最大值'
                    }]
                },
                lineStyle: {
                    normal: {
                        width: 1
                    }
                },
                color: ['#2CC8FF'],
                data: dataY
            }
        ]
        };
        //使用刚刚指定的配置项和数据项显示图表
        myChart.setOption(option);
    }    
  },

  beforeDestroy() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.flexout{
    width:100%;
    display:flex;
    align-items:flex-start;
    justify-content:flex-start;
    margin-bottom:10px;
    height:6rem;
    .line{
      display: inline-block;
      width:4px;
      height:22px;
      background: #00c6ff;
      margin-right:10px; 
    }
    .text{
      font-size: 18px;
      line-height: 26px;
      color: #23c3ff;
    }
}
.flextop{
  height:100%;
  display:flex;
  align-items:center;
  justify-content:flex-start;
  flex-direction: column;
  padding:0px 10px;
   
}
.zhe_box{
  width:100%;
  flex:1;
  overflow: auto;
}
.trend_box{
  width:100%;
  // height:18%;
  position:relative;
  .title{
      font-size: 14px;
      line-height: 24px;
      color: #2ac1ff;
      text-align:left;
  }
  .echartGeology{
    height:120px;
  }
}

.colorblue{
    color: #00bdff;
}
.colorred{
    color: #fd4d4e;
}
.coloryellow{
    color: #fedb4e;
}
</style>